/* eslint 'no-redeclare': 'off', eqeqeq: 'off'  */
import React, { Component } from "react";
import { connect } from "react-redux";
import '../../../../../../Assets/EnsembleStyles/NormalHours.css';
import { Button, Label, Modal, Row, Col } from 'reactstrap';
import TimeCustomization from '../../../../Common/Layouts/Widgets/TimeCustomization';
import ConfirmClearAllDays from '../../_ModalsForms/ClearAllNormalHoursConfirmation';
import AddHoursPeriod from '../../_ModalsForms/AddHoursPeriod';
import classnames from 'classnames';
import Conversions from '../../../../../../Resources/Conversions';
import {PutNormalHoursAction } from '../../../../../../action/tenantAction';
import CustomDropdown from '../CustomDropdown';
import ReactDOM from 'react-dom';

let disabled_States = [];
class EditNormalHours extends Component {

  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      confirmmodal: false,
      addhours_modal: false,
      Sunday:[0,0],
      Monday:[0,0],
      Tuesday:[0,0],
      Wednesday:[0,0],
      Thursday:[0,0],
      Friday:[0,0],
      Saturday:[0,0],
      TenantID : this.props.HoursofOperation_response.tenantId,
      assigned_zones: this.props.TenantZones_response,
      SelectedZoneID: this.props.SelectedZoneId !== undefined ? this.props.SelectedZoneId : (this.props.TenantZones_response !== undefined && this.props.TenantZones_response !== null) ? this.props.TenantZones_response[0].zoneId : 0,
      SelectedZoneName: this.props.SelectedZoneId !== undefined ? this.props.SelectedZoneName : (this.props.TenantZones_response !== undefined && this.props.TenantZones_response !== null) ? this.props.TenantZones_response[0].zoneName : '',
      ZonesHours: [],
      ZoneDropDownStyles: {
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: "9999",
        width: "200px",
        maxHeight: "300px",
        overflowY: "auto",
        border: "1px solid black",
        backgroundColor: "white",
        display: "none",
        "overscroll-behavior-y": "contain" 
      }
    };
    this.toggle = this.toggle.bind(this);
    this.AddHourstoggle = this.AddHourstoggle.bind(this);
    this.Confirmtoggle = this.Confirmtoggle.bind(this);
    this.returnToView = this.returnToView.bind(this);
    this.UpdateNormalHours = this.UpdateNormalHours.bind(this);
    this.someFunctionHere = this.someFunctionHere.bind(this);
    this.SelectAssignedZone = this.SelectAssignedZone.bind(this);
    this.OnSliderChange = this.OnSliderChange.bind(this);
    this.AssignDefaultHours = this.AssignDefaultHours.bind(this);
    this.setWrapperRef = this.setWrapperRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleMouseScroll = this.handleMouseScroll.bind(this);
    this.preventScrollPropagation = this.preventScrollPropagation.bind(this);
    this.ComputeStyle = this.ComputeStyle.bind(this);
    this.setZone = this.setZone.bind(this);
  }

setZone(ZoneID, ZoneName, IsUnchecked){
  let StateChange = { ...this.state.ZoneDropDownStyles };
  StateChange.display = "none";

  this.setState({
      SelectedZoneID: ZoneID,
      SelectedZoneName: ZoneName,
      ZoneDropDownStyles: StateChange,
  });
  this.SelectAssignedZone(ZoneID, IsUnchecked);
}

setWrapperRef(node) {
  this.wrapperRef = node;
}

componentWillUnmount() {
  document.removeEventListener('mousedown', this.handleClickOutside);
  document.removeEventListener('wheel', this.handleMouseScroll);
  document.removeEventListener('mousewheel', this.preventScrollPropagation); 
}

handleClickOutside(event) {
  if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      let StateChange = { ...this.state.ZoneDropDownStyles };
      StateChange.display = "none";
      this.setState({ ZoneDropDownStyles: StateChange });
  }
}

handleMouseScroll(event) {
  if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      let StateChange = { ...this.state.ZoneDropDownStyles };
      StateChange.display = "none";
      this.setState({ ZoneDropDownStyles: StateChange });
  }
}

preventScrollPropagation(event){
  if(this.wrapperRef && this.wrapperRef.contains(event.target)){         //Tenant Dropdown
      var scrollDown = event.wheelDelta < 0;
      if(scrollDown){
          var isAtBottom = this.wrapperRef.scrollTop + this.wrapperRef.clientHeight == this.wrapperRef.scrollHeight;
          if(isAtBottom){
              event.preventDefault();
          }
      }
      else{
          var isAtTop = this.wrapperRef.scrollTop === 0;
          if(isAtTop){
              event.preventDefault();
          }
      }
  }
}

ComputeStyle() {
  var offset = ReactDOM.findDOMNode(this.refs.zoness_in_Select_input).getBoundingClientRect();
  let StateChange = { ...this.state.ZoneDropDownStyles };
  StateChange.display = "block";
  StateChange.top = parseInt(offset.top) + parseInt(offset.height) + 1;
  StateChange.left = parseInt(offset.left);
  this.setState({ ZoneDropDownStyles: StateChange });
}
  
  componentDidMount(){
    var Hours_Slider_div = document.getElementsByClassName('hours');

    if(this.props.HoursofOperation_response != undefined && this.props.HoursofOperation_response != null && this.props.HoursofOperation_response.HoursOfOperation != null){
        
        for (var i = 0; i < Hours_Slider_div.length; i++)
          Hours_Slider_div[i].style.display = 'none';

        let Fulldata = this.props.HoursofOperation_response.HoursOfOperation;
        let data = Fulldata !== undefined && Fulldata !== null && Fulldata.length ? Fulldata.filter(x => x.zoneId === this.state.SelectedZoneID) : []
        
        for(var i=0; i<data.length; i++){
            if(data[i].startTime == data[i].endTime)
            continue;
            switch(data[i].dayId)
            {
                case 0 : 
                this.setState({  
                   Sunday : [Conversions.Convert24hourTimetoValue(data[i].startTime),Conversions.Convert24hourTimetoValue(data[i].endTime)]
                });
                Hours_Slider_div[0].style.display = 'inline';
                break;
                case 1:
                this.setState({  
                   Monday : [Conversions.Convert24hourTimetoValue(data[i].startTime),Conversions.Convert24hourTimetoValue(data[i].endTime)]
                });
                Hours_Slider_div[1].style.display = 'inline';
                break;
                case 2:
                this.setState({  
                  Tuesday : [Conversions.Convert24hourTimetoValue(data[i].startTime),Conversions.Convert24hourTimetoValue(data[i].endTime)]
                });
                Hours_Slider_div[2].style.display = 'inline';
                break;
                case 3:
                this.setState({  
                  Wednesday : [Conversions.Convert24hourTimetoValue(data[i].startTime),Conversions.Convert24hourTimetoValue(data[i].endTime)]
                });
                Hours_Slider_div[3].style.display = 'inline';
                break;
                case 4:
                this.setState({  
                  Thursday : [Conversions.Convert24hourTimetoValue(data[i].startTime),Conversions.Convert24hourTimetoValue(data[i].endTime)]
                });
                Hours_Slider_div[4].style.display = 'inline';
                break;
                case 5:
                this.setState({  
                  Friday : [Conversions.Convert24hourTimetoValue(data[i].startTime),Conversions.Convert24hourTimetoValue(data[i].endTime)]
                });
                Hours_Slider_div[5].style.display = 'inline';
                break;
                case 6:
                this.setState({  
                  Saturday : [Conversions.Convert24hourTimetoValue(data[i].startTime),Conversions.Convert24hourTimetoValue(data[i].endTime)]
                });
                Hours_Slider_div[6].style.display = 'inline';
                break;
                default:
                break;
            }
        }

        if(this.props.HoursofOperation_response.HoursOfOperation !== undefined && this.props.HoursofOperation_response.HoursOfOperation.length)
        {
          let ValidRecords = this.props.HoursofOperation_response.HoursOfOperation.filter(x => x.zoneId !== 0);
          if(ValidRecords !== undefined && ValidRecords !== null && ValidRecords.length)
            this.setState({ ZonesHours : this.props.HoursofOperation_response.HoursOfOperation });
          else
            this.AssignDefaultHours();
        }
        else
          this.AssignDefaultHours();
    }else{
      this.AssignDefaultHours();
    }

        document.addEventListener('mousedown', this.handleClickOutside);
        document.addEventListener('wheel', this.handleMouseScroll);
        document.addEventListener('mousewheel', this.preventScrollPropagation);
}

AssignDefaultHours(){
  if (this.state.assigned_zones !== undefined && this.state.assigned_zones !== null && this.state.assigned_zones.length) {
    let AllZonesNormalHours = [];
    for(let j=0; j<this.state.assigned_zones.length; j++){
      for(let i=0;i<7;i++){
        AllZonesNormalHours.push({
          "dayId": i,
          "zoneId": this.state.assigned_zones[j].zoneId,
          "startTime": Conversions.ConvertValueto24hourTime(0),
          "endTime":Conversions.ConvertValueto24hourTime(0)
        })
      }
    }
    this.setState({ ZonesHours : AllZonesNormalHours })
  }
}

  toggle() {
    this.setState({ modal: !this.state.modal });
  }

  AddHourstoggle() {
    disabled_States = [];
    var Hours_Slider_div = document.getElementsByClassName('hours');
    for(var i=0; i<7; i++){
      if(Hours_Slider_div[i].style.display == 'none'){
        disabled_States.push(i);
      }
    }
    this.setState({  addhours_modal: !this.state.addhours_modal });
  }

  Confirmtoggle() {
    this.setState({ confirmmodal: !this.state.confirmmodal});
  }

  returnToView(){
    this.props.Display("View");
  }
  
  /*  Clear functionality to hide or clear the slider bars */
  ClearAllDays = (e) => {
    this.toggle();

    this.setState(prevState => ({
      ZonesHours: prevState.ZonesHours.map(item => ( item.zoneId === this.state.SelectedZoneID) ? {...item, startTime:Conversions.ConvertValueto24hourTime(0),endTime:Conversions.ConvertValueto24hourTime(0)} : item)
    }))
    
    var Hours_Slider_div = document.getElementsByClassName('hours');
    for (var i = 0; i < Hours_Slider_div.length; i++)
      Hours_Slider_div[i].style.display = 'none';
  }

  /* Fetching Data from child component */
  someFunctionHere(data) {
    this.AddHourstoggle();
    
    if (data != null && data.selected_days != null) {
      let AddedHoursForNewZone = [];
      var Hours_Slider_div = document.getElementsByClassName('hours');
      disabled_States = [];
      for (var i = 0; i < data.selected_days.length; i++) {
        switch (data.selected_days[i]) {
          case "0":
            this.setState({
              Sunday: [data.hours_period[0], data.hours_period[1]]
            });
            AddedHoursForNewZone.push({
              "zoneId": this.state.SelectedZoneID,
              "dayId": 0,
              "startTime": Conversions.ConvertValueto24hourTime(Math.ceil(data.hours_period[0] / 15) * 15),
              "endTime":Conversions.ConvertValueto24hourTime(Math.ceil(data.hours_period[1] / 15) * 15)
            })
            Hours_Slider_div[0].style.display = 'inline';
            break;
          case "1":
            this.setState({
              Monday: [data.hours_period[0], data.hours_period[1]]
            });
            AddedHoursForNewZone.push({
              "zoneId": this.state.SelectedZoneID,
              "dayId": 1,
              "startTime": Conversions.ConvertValueto24hourTime(Math.ceil(data.hours_period[0] / 15) * 15),
              "endTime":Conversions.ConvertValueto24hourTime(Math.ceil(data.hours_period[1] / 15) * 15)
            })
            Hours_Slider_div[1].style.display = 'inline';
            break;
          case "2":
            this.setState({
              Tuesday: [data.hours_period[0], data.hours_period[1]]
            });
            AddedHoursForNewZone.push({
              "zoneId": this.state.SelectedZoneID,
              "dayId": 2,
              "startTime": Conversions.ConvertValueto24hourTime(Math.ceil(data.hours_period[0] / 15) * 15),
              "endTime":Conversions.ConvertValueto24hourTime(Math.ceil(data.hours_period[1] / 15) * 15)
            })
            Hours_Slider_div[2].style.display = 'inline';
            break;
          case "3":
            this.setState({
              Wednesday: [data.hours_period[0], data.hours_period[1]]
            });
            AddedHoursForNewZone.push({
              "zoneId": this.state.SelectedZoneID,
              "dayId": 3,
              "startTime": Conversions.ConvertValueto24hourTime(Math.ceil(data.hours_period[0] / 15) * 15),
              "endTime":Conversions.ConvertValueto24hourTime(Math.ceil(data.hours_period[1] / 15) * 15)
            })
            Hours_Slider_div[3].style.display = 'inline';
            break;
          case "4":
            this.setState({
              Thursday: [data.hours_period[0], data.hours_period[1]]
            });
            AddedHoursForNewZone.push({
              "zoneId": this.state.SelectedZoneID,
              "dayId": 4,
              "startTime": Conversions.ConvertValueto24hourTime(Math.ceil(data.hours_period[0] / 15) * 15),
              "endTime":Conversions.ConvertValueto24hourTime(Math.ceil(data.hours_period[1] / 15) * 15)
            })
            Hours_Slider_div[4].style.display = 'inline';
            break;
          case "5":
            this.setState({
              Friday: [data.hours_period[0], data.hours_period[1]]
            });
            AddedHoursForNewZone.push({
              "zoneId": this.state.SelectedZoneID,
              "dayId": 5,
              "startTime": Conversions.ConvertValueto24hourTime(Math.ceil(data.hours_period[0] / 15) * 15),
              "endTime":Conversions.ConvertValueto24hourTime(Math.ceil(data.hours_period[1] / 15) * 15)
            })
            Hours_Slider_div[5].style.display = 'inline';
            break;
          case "6":
            this.setState({
              Saturday: [data.hours_period[0], data.hours_period[1]]
            });
            AddedHoursForNewZone.push({
              "zoneId": this.state.SelectedZoneID,
              "dayId": 6,
              "startTime": Conversions.ConvertValueto24hourTime(Math.ceil(data.hours_period[0] / 15) * 15),
              "endTime":Conversions.ConvertValueto24hourTime(Math.ceil(data.hours_period[1] / 15) * 15)
            })
            Hours_Slider_div[6].style.display = 'inline';
            break;
          default:
            break;
        }
      }
      for (let i = 0; i < 7; i++) {
        if(!data.selected_days.includes(i.toString())){
          let SelectedZone = this.state.ZonesHours !== undefined && this.state.ZonesHours !== null && this.state.ZonesHours.length ? this.state.ZonesHours.filter(x => x.zoneId === this.state.SelectedZoneID) : []
          if(SelectedZone !== undefined && SelectedZone !== null && SelectedZone.length){
              let SelectedZoneDay = SelectedZone.filter(el => el.dayId === i); 
              if(SelectedZoneDay.length){
                AddedHoursForNewZone.push({
                  "zoneId": this.state.SelectedZoneID,
                  "dayId": i,
                  "startTime": SelectedZoneDay[0].startTime,
                  "endTime": SelectedZoneDay[0].endTime
                })
              }else{
                AddedHoursForNewZone.push({
                  "zoneId": this.state.SelectedZoneID,
                  "dayId": i,
                  "startTime": Conversions.ConvertValueto24hourTime(0),
                  "endTime": Conversions.ConvertValueto24hourTime(0)
                })
              }
          }else{
            AddedHoursForNewZone.push({
              "zoneId": this.state.SelectedZoneID,
              "dayId": i,
              "startTime": Conversions.ConvertValueto24hourTime(0),
              "endTime": Conversions.ConvertValueto24hourTime(0)
            })
          }
        }
        if (Hours_Slider_div[i].style.display == 'none') {
          disabled_States.push(i);
        }
      }

      let SelectedZoneData = this.state.ZonesHours !== undefined && this.state.ZonesHours !== null && this.state.ZonesHours.length ? this.state.ZonesHours.filter(x => x.zoneId === this.state.SelectedZoneID) : []
      if (SelectedZoneData === undefined || SelectedZoneData === null || SelectedZoneData.length <= 0) {
        let MergedData = [...this.state.ZonesHours, ...AddedHoursForNewZone];
        this.setState({ ZonesHours: MergedData });
      } else {
        let MergedData = [...this.state.ZonesHours.filter(e => !AddedHoursForNewZone.some(el => el.zoneId === e.zoneId && el.dayId === e.dayId)), ...AddedHoursForNewZone];
        this.setState({ ZonesHours: MergedData });
      }
    }   
}

  /* Save Normal hours Function */
  UpdateNormalHours() {
    let AllZonesNormalHours = [];
    if (this.state.SelectedZoneID === -1 && this.state.SelectedZoneName === 'Select All') {
      let WithSelectAllData = this.state.ZonesHours !== undefined && this.state.ZonesHours !== null && this.state.ZonesHours.length ? this.state.ZonesHours.filter(x => Number(x.zoneId) === -1) : [];
      if (WithSelectAllData !== undefined && WithSelectAllData !== null && WithSelectAllData.length) {
        var AllUpdatedZoneHours = [];
        for (var i = 0; i < this.state.assigned_zones.length; i++) {
          for (var j = 0; j < 7; j++) {
            AllUpdatedZoneHours.push({
              "zoneId": this.state.assigned_zones[i].zoneId,
              "dayId": WithSelectAllData[j].dayId,
              "startTime": WithSelectAllData[j].startTime,
              "endTime": WithSelectAllData[j].endTime
            })
          }
        }
        AllZonesNormalHours = AllUpdatedZoneHours;
      }
    } else {
      AllZonesNormalHours = (this.state.ZonesHours !== undefined && this.state.ZonesHours !== null && this.state.ZonesHours.length) ? this.state.ZonesHours : [];
    }
    this.props.PutNormalHoursAction(AllZonesNormalHours, this.state.TenantID);
    this.returnToView();
  }

  SelectAssignedZone(selectedZoneID, IsUnchecked){
    this.setState({
      Sunday:[0,0],
      Monday:[0,0],
      Tuesday:[0,0],
      Wednesday:[0,0],
      Thursday:[0,0],
      Friday:[0,0],
      Saturday:[0,0]
    });

    if(IsUnchecked){
      let WithoutSelectAllData = this.state.ZonesHours !== undefined && this.state.ZonesHours !== null && this.state.ZonesHours.length ? this.state.ZonesHours.filter(x => Number(x.zoneId) !== -1) : [];
      this.setState({ ZonesHours: WithoutSelectAllData })
    }else{
      if(Number(selectedZoneID) === -1){
        let AddedHoursForNewZone = [];
        for(let i=0;i<7;i++){
          AddedHoursForNewZone.push({
            "zoneId": -1,
            "dayId": i,
            "startTime": Conversions.ConvertValueto24hourTime(0),
            "endTime":Conversions.ConvertValueto24hourTime(0)
          })
        }
        let MergedData = [...this.state.ZonesHours, ...AddedHoursForNewZone];
        this.setState({ ZonesHours: MergedData });
      }
    }
    
    let data = this.state.ZonesHours !== undefined && this.state.ZonesHours !== null && this.state.ZonesHours.length ? this.state.ZonesHours.filter(x => x.zoneId === Number(selectedZoneID)) : []
    
    var Hours_Slider_div = document.getElementsByClassName('hours');
    for (var i = 0; i < Hours_Slider_div.length; i++)
    Hours_Slider_div[i].style.display = 'none';

    if (data !== undefined && data !== null && data.length) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].startTime == data[i].endTime)
          continue;
        switch (data[i].dayId) {
          case 0:
            this.setState({
              Sunday: [Conversions.Convert24hourTimetoValue(data[i].startTime), Conversions.Convert24hourTimetoValue(data[i].endTime)]
            });
            Hours_Slider_div[0].style.display = 'inline';
            break;
          case 1:
            this.setState({
              Monday: [Conversions.Convert24hourTimetoValue(data[i].startTime), Conversions.Convert24hourTimetoValue(data[i].endTime)]
            });
            Hours_Slider_div[1].style.display = 'inline';
            break;
          case 2:
            this.setState({
              Tuesday: [Conversions.Convert24hourTimetoValue(data[i].startTime), Conversions.Convert24hourTimetoValue(data[i].endTime)]
            });
            Hours_Slider_div[2].style.display = 'inline';
            break;
          case 3:
            this.setState({
              Wednesday: [Conversions.Convert24hourTimetoValue(data[i].startTime), Conversions.Convert24hourTimetoValue(data[i].endTime)]
            });
            Hours_Slider_div[3].style.display = 'inline';
            break;
          case 4:
            this.setState({
              Thursday: [Conversions.Convert24hourTimetoValue(data[i].startTime), Conversions.Convert24hourTimetoValue(data[i].endTime)]
            });
            Hours_Slider_div[4].style.display = 'inline';
            break;
          case 5:
            this.setState({
              Friday: [Conversions.Convert24hourTimetoValue(data[i].startTime), Conversions.Convert24hourTimetoValue(data[i].endTime)]
            });
            Hours_Slider_div[5].style.display = 'inline';
            break;
          case 6:
            this.setState({
              Saturday: [Conversions.Convert24hourTimetoValue(data[i].startTime), Conversions.Convert24hourTimetoValue(data[i].endTime)]
            });
            Hours_Slider_div[6].style.display = 'inline';
            break;
          default:
            break;
        }
      }
    }
  }

  OnSliderChange(DayID, e){
    let startTime = Conversions.ConvertValueto24hourTime(Math.ceil(e.values[0] / 15) * 15);
    let endTime = Conversions.ConvertValueto24hourTime(Math.ceil(e.values[1] / 15) * 15);
    this.setState(prevState => ({
      ZonesHours: prevState.ZonesHours.map(item => (
        this.state.SelectedZoneID === item.zoneId && DayID === item.dayId ? { ...item, startTime, endTime } : item
      ))
    }))

    switch (DayID) {
      case 0:
        this.setState({ Sunday: [Math.ceil(e.values[0] / 15) * 15, Math.ceil(e.values[1] / 15) * 15] });
        break;
      case 1:
        this.setState({ Monday: [Math.ceil(e.values[0] / 15) * 15, Math.ceil(e.values[1] / 15) * 15] })
        break;
      case 2:
        this.setState({ Tuesday: [Math.ceil(e.values[0] / 15) * 15, Math.ceil(e.values[1] / 15) * 15] })
        break;
      case 3:
        this.setState({ Wednesday: [Math.ceil(e.values[0] / 15) * 15, Math.ceil(e.values[1] / 15) * 15] })
        break;
      case 4:
        this.setState({ Thursday: [Math.ceil(e.values[0] / 15) * 15, Math.ceil(e.values[1] / 15) * 15] })
        break;
      case 5:
        this.setState({ Friday: [Math.ceil(e.values[0] / 15) * 15, Math.ceil(e.values[1] / 15) * 15] })
        break;
      case 6:
        this.setState({ Saturday: [Math.ceil(e.values[0] / 15) * 15, Math.ceil(e.values[1] / 15) * 15] })
        break;
      default:
        break;
    }
  }

    render(HoursofOperation_response,AddHoursPeriodFromModal_response) {
     //let AssignedZones = this.props.TenantAssignedZones;
      return (
        <div>
        <div className="Customised_form_div">
      <Label >Define the Normal Hours of operation for the tenant zones. When employees make requests outside of these hours, the tenant will be invoiced. </Label>
      <div style={{"margin-top":"15px"}}>
         <Row>
         <Col style={{"max-width":  this.props.OnPremises ? "15%":"13%"}}>
            <span style={{"font-size": "13px", "position": "relative", "top": "-10px"}}><b>Assigned Zones</b><br/>
            <input type="text" ref='zoness_in_Select_input' style={{ width: '150px', height: '22px', backgroundColor: 'white' }} className="minimal workorderedit-dropdown" placeholder={this.state.SelectedZoneID === 0 ? "--Select--" : this.state.SelectedZoneName} onClick={this.ComputeStyle} />
              {/* <select id='rdl_Assigned_zones' ref='AssignedZones_in_Select_input' onChange={this.SelectAssignedZone} className="InputFieldStyle" style={{"height":"22px"}}>
                {AssignedZones}
              </select> */}
            </span>
          </Col>
          <Col style={{"padding-left":"0px"}}>
            <Button type="button" className="btn btn-success" onClick={this.AddHourstoggle}>Add Hours Period</Button>
            <Button type="button" className="btcn btn-black" onClick={this.toggle}>Clear All Days</Button>
          </Col>
         </Row>
      </div>
     
       <table className="Hours_widget" >
          <tbody>
          <tr className="Hours_label_row">
              <td >&nbsp;</td>
              <td ><span>
              <p className="hours_number">12 AM</p>
              <p className="hours_number">2:00</p>
              <p className="hours_number">4:00</p>
              <p className="hours_number">6:00</p>
              <p className="hours_number">8:00</p>
              <p className="hours_number">10:00</p>
              <p className="hours_number">12 PM</p>
              <p className="hours_number">2:00</p>
              <p className="hours_number">4:00</p>
              <p className="hours_number">6:00</p>
              <p className="hours_number">8:00</p>
              <p className="hours_number">10:00</p>
              </span>
                  </td></tr>

                  {/* {NormalHoursslider} */}
              <tr className="slider_row"><td className="day"><p>Sunday</p></td><td ><div  className="hours" ><TimeCustomization  values={this.state.Sunday}   
              onChange={e => this.OnSliderChange(0, e)} min={0} max={1425}  /> </div></td></tr>
              <tr className="slider_row"><td className="day"><p>Monday</p></td><td ><div  className="hours" ><TimeCustomization    values={this.state.Monday}  
              onChange={e => this.OnSliderChange(1, e)}  min={0} max={1425} /> </div></td></tr>
              <tr className="slider_row"><td className="day"><p>Tuesday</p></td><td ><div  className="hours" ><TimeCustomization    values={this.state.Tuesday}    
              onChange={e => this.OnSliderChange(2, e)}  min={0} max={1425} /> </div></td></tr>
              <tr className="slider_row"><td className="day"><p>Wednesday</p></td><td ><div  className="hours" ><TimeCustomization   values={this.state.Wednesday}   
              onChange={e => this.OnSliderChange(3, e)}  min={0} max={1425} /> </div></td></tr>
              <tr className="slider_row"><td className="day"><p>Thursday</p></td><td ><div  className="hours" ><TimeCustomization   values={this.state.Thursday}   
              onChange={e => this.OnSliderChange(4, e)}  min={0} max={1425} /> </div></td></tr>
              <tr className="slider_row"><td className="day"><p>Friday</p></td><td ><div  className="hours" ><TimeCustomization  values={this.state.Friday}    
              onChange={e => this.OnSliderChange(5, e)}  min={0} max={1425} /> </div></td></tr>
              <tr className="slider_row"><td className="day"><p>Saturday</p></td><td ><div  className="hours" ><TimeCustomization   values={this.state.Saturday}  
              onChange={e => this.OnSliderChange(6, e)}  min={0} max={1425} /> </div></td></tr>


              {/* <tr className="slider_row"><td className="day"><p>Saturday</p></td><td ><div  className="hours" ><TimeCustomization  ref='Weekday' id="test_input"  values={[0,0]} min={0}   onChange={ this.sliderChange}  min={0} max={1440} /> </div></td></tr> */}
              </tbody>
          </table>


         <Button type="button" className="btn btn-gray" onClick={ this.returnToView } >Cancel</Button>
         <Button type="button" className="btn btn-success" onClick={this.UpdateNormalHours}>Save  </Button>
   
           </div>



          {/* Add Hours Period Modal */}
          <Modal isOpen={this.state.addhours_modal} addhours_modal={this.addhours_modal} className={classnames({ classnames: this.props.className }, "ModalContainer")} >
            <AddHoursPeriod  someFunctionHere={this.someFunctionHere} disabled_States = {disabled_States} />
          </Modal>


          {/* Clear All Days Modal */}
          <Modal isOpen={this.state.modal} toggle={this.toggle} className={classnames({ classnames: this.props.className }, "ModalContainer")} >
            <ConfirmClearAllDays ClearAllDays={this.ClearAllDays} toggle={this.toggle} />
          </Modal>

          <CustomDropdown name="tenantdropdown" refMethod={this.setWrapperRef} groupname="rdTenant" data={this.state.assigned_zones} elementStyle={this.state.ZoneDropDownStyles} setValue={this.setZone} SelectedZoneID={this.state.SelectedZoneID} />
</div>

      );
    }
    }



const mapStateToProps = state => {
  return {
    HoursofOperation_response: state.ViewtenantsRootReducer.HoursofOperation,
    AddHoursPeriodFromModal_response: state.ViewtenantsRootReducer.AddHoursPeriodFromModal,
    TenantZones_response: state.ViewtenantsRootReducer.TenantZones,
    OnPremises: state.authService.IsOnPremise
  };
};

const mapDispatchToProps = dispatch => {
  return {
    PutNormalHoursAction: (NormalHoursEditedData,TenantID) => dispatch(PutNormalHoursAction(NormalHoursEditedData,TenantID)),
  };
}; 

export default connect(mapStateToProps, mapDispatchToProps)(EditNormalHours);




